import { useState } from 'react';

import type { DraggableEvent } from 'react-draggable';

import { MODAL_DEFAULTS } from '@shared/components/findings/faceted-filtering/constants';

interface UseRndModalOptions {
  initialLeft?: number;
  initialTop?: number;
  initialWidth?: number;
  initialHeight?: number;
  minWidth?: number;
  maxWidth?: number;
  minHeight?: number;
  maxHeight?: number;
  dragAxis?: 'x' | 'y' | 'both';
  resizeAxis?: 'x' | 'y' | 'both';
}

export function useRndModal({
  initialLeft = MODAL_DEFAULTS.initialLeft,
  initialTop = MODAL_DEFAULTS.initialTop,
  initialWidth = MODAL_DEFAULTS.initialWidth,
  minWidth = MODAL_DEFAULTS.minWidth,
  maxWidth = MODAL_DEFAULTS.maxWidth,
  dragAxis = 'x',
}: UseRndModalOptions = {}) {
  const [position, setPosition] = useState({ x: initialLeft, y: initialTop });
  const [width, setWidth] = useState(initialWidth);

  const onDragStop = (_: DraggableEvent, data: { x: number; y: number }) => {
    setPosition({ x: data.x, y: data.y });
  };

  const onResizeStop = (
    _: MouseEvent | TouchEvent,
    _dir: string,
    ref: HTMLElement,
    _delta: { width: number; height: number },
    pos: { x: number; y: number },
  ) => {
    setWidth(ref.offsetWidth);
    setPosition(pos);
  };

  const enableResizing = {
    top: false,
    right: true,
    bottom: false,
    left: true,
    topRight: false,
    bottomRight: false,
    bottomLeft: false,
    topLeft: false,
  };

  const dragProps = {
    enableResizing,
    disableDragging: dragAxis !== 'x' && dragAxis !== 'both',
    minWidth,
    maxWidth,
    onDragStop,
    onResizeStop,
  };

  return {
    position,
    width,
    setPosition,
    setWidth,
    dragProps,
    initialLeft,
    initialTop,
  };
}
